"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useMultiStyleConfig, forwardRef } from "@chakra-ui/react";
const InnerDrawerContent = forwardRef(({ children }, ref) => {
    const styles = useMultiStyleConfig("InnerDrawer");
    return (_jsx(Box, Object.assign({ ref: ref, sx: styles.drawerContent }, { children: children })));
});
InnerDrawerContent.displayName = "InnerDrawerContent";
export default InnerDrawerContent;
//# sourceMappingURL=InnerDrawerContent.js.map